import * as React from 'react';
import { SVGProps } from 'react';

const IconAlertSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0zM5 7V2h2v5H5zm2.028 1h-2v2H7l.028-2z"
    />
  </svg>
);
export default IconAlertSizeXs;
